import { apolloClient } from "../../../src/graphql/apolloClient";
import { COUNTRY_RANKINGS_QUERY } from "../../../src/pages/rankings/countryRankings/query";
import { CPProductClass } from "../../../src/types/countryProfileEnums";

// Prefetch the country rankings query into the shared Apollo cache so the
// component's useQuery hits cache on mount during client-side navigation.
export async function clientLoader() {
  await apolloClient.query({
    query: COUNTRY_RANKINGS_QUERY,
    variables: { productClass: CPProductClass.HS12 },
    fetchPolicy: "cache-first",
  });
  return null;
}
clientLoader.hydrate = false as const;

// Rankings index (country rankings default view)
// Stub for typegen — runtime routing handled by RankingsLayout
export default function RankingsIndex() {
  return null;
}
